import { newAxiosInstance } from "../axiosInstance";

export const newGetAllCategories = async () => {
  try {
    // const response = await newAxiosInstance.get("/categories/?page=1&page_size=10");
    const response = await newAxiosInstance.get("/categories/hierarchy");
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
}

export const getNewFilteredProducts = async ({
  id,
  brandName,
  pageNumber,
  pageSize,
  stockStatus,
  value,
  // order,
  search,
  categorySlug,
}: {
  id?: number;
  brandName?: string;
  pageNumber?: number;
  pageSize?: number;
  stockStatus?: string;
  value?: string;
  order?: string;
  search?: string;
  categorySlug?: string;
}) => {
  try {
    // Using an object to ensure unique query parameters
    const queryParams: Record<string, string | number> = {
      page: pageNumber ?? 1, // Default to 1 if undefined
      page_size: pageSize ?? 12, // Default to 10 if undefined
    };

    if (id) queryParams["category"] = id;
    if (categorySlug) queryParams["category_slug"] = categorySlug;
    if (brandName) queryParams["filter_brand"] = brandName;
    if (stockStatus) queryParams["stock_status"] = stockStatus;
    if (value) {
      queryParams["sort"] = value;
    }
    if (search) queryParams["search"] = search;

    // Convert object to query string
    const queryString = new URLSearchParams(queryParams as Record<string, string>).toString();
    const endpoint = `/products?${queryString}`;

    const response = await newAxiosInstance.get(endpoint);

    return {
      data: response.data,
      headers: response.headers || {},
    };
  } catch (error) {
    console.error("Error fetching products:", error);
    return { data: [], headers: {} };
  }
};

export const getNewProductDetails = async (id: string) => {
  try {
    const response = await newAxiosInstance.get(`/products/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching product details", error);
    return [];
  }
}

export const getNewProductDetailsBySlug = async (slug: string) => {
  try {
    const response = await newAxiosInstance.get(`/products/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching product details", error);
    return [];
  }
}